






















import { Vue, Component, Prop } from "vue-property-decorator";
import CompanyPlace from "@/models/CompanyPlace";
import { currentCompanyStore } from "@/store/typed";

@Component
export default class CompanyPlaceItem extends Vue {
  @Prop({ required: true }) readonly companyPlace!: CompanyPlace;
  @Prop({ default: false }) readonly deletable!: boolean;

  private item = Object.assign(new CompanyPlace(), this.companyPlace);

  get fullAddress() {
    if (this.status === "incomplete") {
      return "Indirizzo incompleto";
    }
    return this.companyPlace.fullAddress;
  }

  get status() {
    if (
      this.companyPlace.source === "google_places" &&
      this.companyPlace.status === "not_found"
    ) {
      return "incomplete";
    }
    if (
      this.companyPlace.source === "google_places" &&
      this.companyPlace.status === "parsing"
    ) {
      return "loading";
    }
    return "ok";
  }

  hovered = false;

  onDelete() {
    currentCompanyStore.destroyCompanyPlace(this.companyPlace.id);
  }

  onSelectClicked() {
    this.$emit("poi-selected", this.companyPlace.id);
  }
}
